<template>
  <div>
    <div class="modal" v-bind:class="{'is-active':isActive}">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Create Player</p>
          <button class="delete" aria-label="close" @click="close"></button>
        </header>
        <section class="modal-card-body">
          <div class="field">
            <label class="label">Number #</label>
            <div class="control">
              <input class="input" type="number" min=1 max=99 step=1 placeholder=88 v-model="formData.number">
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label">First Name</label>
                <div class="control">
                  <input class="input" type="text" placeholder="Joey" v-model="formData.forename">
                </div>
              </div>
              <div class="field">
                <label class="label">Last Name</label>
                <div class="control">
                  <input class="input" type="text" placeholder="Martin" v-model="formData.surname">
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">Date of Birth</label>
                <div class="control">
                  <input class="input" type="date" placeholder="Mar 15 2001" v-model="formData.dob">
                </div>
              </div>
              <div class="field">
                <label class="label">Place of Birth</label>
                <div class="control">
                  <input class="input" type="text" placeholder="Canada" v-model="formData.birth_place">
                </div>
              </div>
              <div class="field">
                <label class="label">Nationality</label>
                <div class="control">
                  <input class="input" type="text" placeholder="Canada" v-model="formData.nationality">
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">Position</label>
                <div class="control">
                  <div class="select is-medium">
                    <select v-model="formData.position">
                      <option value="C">Forward</option>
                      <option value="LW">Left Forward</option>
                      <option value="C">Center Forward</option>
                      <option value="RW">Right Forward</option>
                      <option value="LD">Defense</option>
                      <option value="LD">Left Defense</option>
                      <option value="RD">Right Defense</option>
                      <option value="GT">Goaltender</option>
                      <option value="BKUPGT">Backup Goaltender</option>
                      <option value="EMRGGT">Emergency Goaltender</option>
                      <option value="COACH">Coach</option>
                      <option value="ASSCOACH">Assistant Coach</option>
                  </select>
                  </div>
                </div>
              </div>
              <div class="field">
                <label class="label">Height (m)</label>
                <div class="control">
                  <input class="input" min=1 max=6 step=0.01 type="number" placeholder="1.93m" v-model="formData.height">
                </div>
              </div>
              <div class="field">
                <label class="label">Weight (kg)</label>
                <div class="control">
                  <input class="input" min=30 max=900 step=0.01 type="number" placeholder="93kg" v-model="formData.weight">
                </div>
              </div>
              <div class="field">
                <label class="label">Handedness (Left / Right)</label>
                <div class="control">
                  <div class="select is-medium">
                    <select v-model="formData.handedness">
                      <option>Left</option>
                      <option>Right</option>
                  </select>
                  </div>
                </div>
              </div>
            </div>
        </div>
        
        </section>
        <footer class="modal-card-foot">
          <button class="button is-success" @click="save">Save</button>
          <button class="button" @click="close">Cancel</button>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Notification from 'vue-bulma-notification'
const NotificationComponent = Vue.extend(Notification)
const openNotification = (propsData = {
  title: '',
  message: '',
  type: '',
  direction: '',
  duration: 4500,
  container: '.notifications'
}) => {
  return new NotificationComponent({
    el: document.createElement('div'),
    propsData
  })
}
export default {
  components: {
    Notification
  },
  data () {
    return {
      formData: {
        'team_id': 0,
        'forename': '',
        'surname': '',
        'number': 0,
        'position': '',
        'age': 0,
        'dob': 0,
        'height': 0,
        'weight': 0,
        'handedness': '',
        'birth_place': '',
        'nationality': '',
        'status': 'Active',
        'external_url': 'none'
      },
      nameMax: 28,
      descriptionMax: 500,
      currentName: 0,
      isActive: false,
      image_path: ''
    }
  },
  methods: {
    launch: function () {
      this.isActive = true
    },
    close: function () {
      this.isActive = false
    },
    onImageChange (_fileInput) {
      this.image_path = _fileInput.target.files[0]
    },
    save: function () {
      console.log('Formdata is: ' + this.formData)
      let post = new FormData() // eslint-disable-line no-undef
      this.formData.team_id = this.$route.params.teamId
      post.append('player', JSON.stringify(this.formData))
      console.log('post is: ' + post)
      this.$http.post('https://devilsapi.roblutken.com/api/players/add/', post, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(
        response => {
          console.log(response)
          if (response.data.status === '202') {
            openNotification({
              title: 'Update Success',
              message: response.data.message,
              type: 'success',
              duration: 3400
            })
          } else {
            openNotification({
              title: 'Failed to update',
              message: response.data.message,
              type: 'danger',
              duration: 3400
            })
          }
          this.close()
          console.log('dataUpdate')
          this.$emit('dataUpdate', 'test')
          this.$router.push('/editors/player-editor/' + this.$route.params.teamId)
        }
      )
    },
    openNotificationWithType (type) {
      openNotification({
        title: 'This is a title',
        message: 'This is the message.',
        type: type
      })
    }
  }
}
</script>

<style>
.modal-card{
  position:absolute;
  display:initial;
  top:10em;
}
textarea,
.textarea {
  min-height: 150px;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// new-player-dialog.vue?b728045c